import React from 'react';
import Footer from './Footer';

import * as styles from '../styles/layout.module.css';

export default function Layout({ children }) {
  return (
    <>
      <div className={styles.content}>
        {children}
      </div>
      <Footer></Footer>
    </>
  )
}